export const UNSPECIFIED = 'Unspecified';

export const RfiEnums = {
  costImpact: [
    "Yes",
    "No",
    "Unknown",
  ],
  scheduleImpact: [
    "Yes",
    "No",
    "Unknown",
  ],
  priority: [
    "High",
    "Normal",
    "Low",
  ],
  discipline: [
    "Architectural",
    "Civil/Site",
    "Concrete",
    "Electrical",
    "Exterior Envelope",
    "Fire Protection",
    "Interior/Finishes",
    "Landscaping",
    "Masonry",
    "Mechanical",
    "Plumbing",
    "Structural",
    "Other",
  ],
  category: [
    "Code Compliance",
    "Constructability",
    "Design Coordination",
    "Documentation Conflict",
    "Documentation Incomplete",
    "Field condition",
    "Other",
  ],
};
